<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal="false"
    :show-close='false'
    title="请确认offer"
  >
    <el-container
      v-loading.fullscreen.lock="loading"
      element-loading-text="正在锁定数据，确认offer后，不再对数据进行计算，待人选12%的数据确认之后，可进入【工作台-业绩分成】进入分成流程"
      style="flex-direction: column"
    >
      <template v-if="showZerenren">
        <span class="tips">此部分数据涉及业绩分成，请仔细确认</span>
        <div class="info-part">
          <div class="info-content">
            <div class="info-item">
              <div class="info-item-title">成单顾问：</div>
              <div class="info-item-content">{{user.account}}({{user.姓名}})</div>
            </div>
            <div class="info-item">
              <div class="info-item-title">客户开发：</div>
              <div class="info-item-content">{{客户开发}}</div>
            </div>
          </div>
        </div>
        <div class="info-part">
          <div class="info-content">
            <div class="info-item">
              <div
                class="info-item-title"
                style="display:flex;align-items:center"
              >团队长
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="团队长请选择成单顾问所在团队的团队长，成单顾问为团队长，可以填自己"
                  placement="top"
                >
                  <el-button
                    icon="el-icon-question"
                    type="text"
                    style="padding:0"
                  ></el-button>
                </el-tooltip>
                ：
              </div>
              <div class="info-item-content">
                <el-select
                  v-model="团队长"
                  size="mini"
                  filterable
                  :multiple-limit='1'
                  multiple
                >
                  <el-option
                    v-for="item in users"
                    :key="item._id"
                    :label="item.姓名+`(${item.account})`"
                    :value="item.account"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="info-item">
              <div class="info-item-title">客户维护：</div>
              <div class="info-item-content"><el-select
                  v-model="客户维护"
                  size="mini"
                  filterable
                  :multiple-limit='1'
                  multiple
                >
                  <el-option
                    v-for="item in users"
                    :key="item._id"
                    :label="item.姓名+`(${item.account})`"
                    :value="item.account"
                  ></el-option>
                </el-select></div>
            </div>
            <div class="info-item">
              <div class="info-item-title">项目对接：</div>
              <div class="info-item-content"><el-select
                  v-model="项目对接"
                  size="mini"
                  :multiple-limit='1'
                  multiple
                  filterable
                >
                  <el-option
                    v-for="item in users"
                    :key="item._id"
                    :label="item.姓名+`(${item.account})`"
                    :value="item.account"
                  ></el-option>
                </el-select></div>
            </div>
            <div class="info-item">
              <div class="info-item-title">项目经理：</div>
              <div class="info-item-content"><el-select
                  v-model="项目经理"
                  size="mini"
                  multiple
                  filterable
                >
                  <el-option
                    v-for="item in users"
                    :key="item._id"
                    :label="item.姓名+`(${item.account})`"
                    :value="item.account"
                  ></el-option>
                </el-select></div>
            </div>
          </div>
        </div>
      </template>
      <el-form
        ref="form"
        :model="form"
        label-width="120px"
        size="mini"
      >
        <el-form-item label="候选人:"> {{ form['候选人'] }} </el-form-item>
        <el-form-item label="推荐顾问:"> {{ form['顾问'] }} </el-form-item>
        <el-form-item
          label="职位"
          required
        >
          <el-input
            v-model="form['职位']"
            placeholder="客户给到的职位"
          ></el-input>
        </el-form-item>
        <el-form-item label="专业职级">
          <el-input
            v-model="form['专业职级']"
            placeholder="客户给到的专业职级"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="固定年薪"
          required
        >
          <el-input
            v-model="form['固定年薪']"
            placeholder="填写全年的固定薪酬"
            @change="changeYongjin"
            @blur="checkAnnualSalary(false)"
          >
            <template slot="append">
              万
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="offer签订日期">
          <el-date-picker
            v-model="form['offer签订日期']"
            type="date"
            placeholder="选择日期"
          > </el-date-picker>
        </el-form-item>
        <el-form-item label="预计到岗时间">
          <el-date-picker
            v-model="form['预计到岗时间']"
            type="date"
            placeholder="选择日期"
          > </el-date-picker>
        </el-form-item>
        <el-form-item
          label="到岗日期"
          required
        >
          <el-date-picker
            v-model="form['到岗日期']"
            type="date"
            placeholder="选择日期"
          > </el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="form['备注']"
            placeholder="特殊说明可填写备注"
          ></el-input>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item
          label="合同比例"
          required
        >
          <el-col :span="12">
            <el-select
              v-model="biliType"
              @change="changeYongjin"
            >
              <el-option
                label="选择比例"
                value="选择比例"
              ></el-option>
              <el-option
                label="固定收费"
                value="固定收费"
              ></el-option>
              <el-option
                label="最低收费"
                value="最低收费"
              ></el-option>
            </el-select>
          </el-col>
          <el-col
            :span="10"
            v-if="biliType == '选择比例'"
          >
            <el-input
              v-model="form['合同比例']"
              placeholder="点击查看合同附件可查看合同"
              @change="changeYongjin"
            ></el-input>
          </el-col>
          <el-col
            :span="2"
            v-if="biliType == '选择比例'"
          > % </el-col>
        </el-form-item>
        <el-form-item
          label="试用期"
          required
        >
          <el-col :span="12"> <el-input
              v-model="form['试用期']"
              placeholder="填写数字"
            ></el-input> </el-col>
          <el-col :span="12"> <span>个月</span> </el-col>
        </el-form-item>
        <el-form-item
          label="佣金额"
          required
        >
          <el-input
            v-model="form['佣金额']"
            :disabled="biliType == '选择比例'"
            :placeholder="biliType == '选择比例' ? '请填写固定年薪和合同比例' : '请输入数字，用于开票和业绩计算'"
          >
            <template slot="append">
              万
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="rpg-dialog-item rpg-pdl-130">
        <HetongFijian
          ref="HetongFijian"
          :companyName="project.客户公司"
        ></HetongFijian>
      </div>
    </el-container>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        size="small"
        @click="dialogVisible = false"
        style="margin-right:10px"
      >取 消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="confirm"
      >确 定</el-button>
    </span>

    <el-dialog
      :visible.sync="checkDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :append-to-body="true"
      :modal="true"
      :center="true"
      width="400px"
      title="确认年薪"
    >
      <p class="mb10">
        哇哦，您确定这一单的固定年薪已经<b class="ml10 mr10" style="color:#F56C6C">上亿</b>了吗，这里的单位是<b
          class="ml10 mr10"
          style="color:#F56C6C"
          >万</b
        >哦，如果确定的话，恭喜您成了一个超级大单哦!
      </p>
      <p class="mb10" style="text-align:center">(ง •̀_•́)ง</p>
      <div class="rpg-dialog-item rpg-text-center">
        <el-button size="mini" type="primary" @click="closeCheckDialog">
          {{ checkDialogCloseTime > 0 ? `${checkDialogCloseTime}s之后即可关闭` : '关闭' }}
        </el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>
<script>
import HetongFijian from './hetong-fujian'
import project_notify from '../constant/project_notify'
import { getYongJin } from '../constant/common-methods'
export default {
  components: { HetongFijian },
  props: {
    onConfirm: {
      type: Function,
      default: function () {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      rid: '',
      pid: '',
      form: {},
      biliType: '选择比例',
      radish: {},
      project: {},
      user: app.user,
      users: app.users.filter((u) => u.状态 !== '已离职'),
      客户开发: [],
      团队长: [],
      客户维护: [],
      项目对接: [],
      项目经理: [],
      loading: false,
      yejifencheng: null,
      showZerenren: true,

      checkDialogVisible: false,
      checkDialogCloseTime: 0,
      beforeConfirmCheck: false,
    }
  },
  methods: {
    checkAnnualSalary(confirmCheck) {
      const num = parseInt(this.form.固定年薪) || 0
      if (num >= 10000) {
        this.checkDialogCloseTime = 5
        this.checkDialogVisible = true
        this.setTimeOut(this.checkDialogCloseTime)
      }
      if (confirmCheck) {
        this.beforeConfirmCheck = true
        if (num < 10000) this.confirm()
      }
    },
    setTimeOut(time) {
      if (time) {
        setTimeout(() => {
          this.checkDialogCloseTime = time - 1
          this.setTimeOut(this.checkDialogCloseTime)
        }, 1000)
      }
    },
    closeCheckDialog() {
      if (this.checkDialogCloseTime <= 0) this.checkDialogVisible = false
    },
    // async open(params) {
    //   const { radish, project } = params
    //   this.rid = radish.rid || radish._id
    //   this.pid = project._id
    //   this.radish = radish
    //   this.project = project
    //   const res = await app.service('radish').findOffer({ rid: this.rid, pid: this.pid })
    //   if (res.status === 'success') {
    //     if (res.data.length > 0) {
    //       this.form = res.data[0]
    //       if (this.form.合同比例 == '固定收费' || this.form.合同比例 == '最低收费') {
    //         this.biliType = this.form.合同比例
    //       } else {
    //         this.biliType = '选择比例'
    //       }
    //       this.dialogVisible = true
    //     } else {
    //       this.$message.error('未找到对应offer数据')
    //     }
    //   } else {
    //     return this.$message.error(res.msg)
    //   }
    // },
    async handleConfirmOffer() {
      // let intNum = /^[0-9]*$/
      let floatNum = /^\d+(\.\d+)?$/
      const form = Object.assign({}, this.form)
      if (!form.职位) return this.$message('请填写职位')
      if (!form.固定年薪) return this.$message('请填写固定年薪')
      if (!form.到岗日期) return this.$message('请填写到岗日期')
      if (!form.试用期) return this.$message('请填写试用期')
      if (!form.佣金额) return this.$message('请填写佣金额')
      if (!floatNum.test(form.固定年薪)) return this.$message('固定年薪只能填写数字')
      if (!floatNum.test(form.试用期)) return this.$message('试用期只能填写数字')
      if (!floatNum.test(form.佣金额)) return this.$message('佣金额只能填写数字')
      if (this.biliType == '选择比例') {
        if (!form.合同比例) return this.$message('请填写合同比例')
        if (!floatNum.test(form.合同比例)) return this.$message('合同比例只能填写数字')
      }
      form.isMaybe = false
      if (this.biliType == '固定收费' || this.biliType == '最低收费') form.合同比例 = this.biliType
      const res = await app
        .service('radish')
        .updateOffer({ rid: this.rid, pid: this.pid, data: this.form, type: 'confirm' })
      if (res.status == 'success') {
        const keys = '候选人、推荐顾问、职位、专业职级、固定年薪、offer签订日期、预计到岗时间、到岗日期、备注'
        const content = project_notify.getContent(this.form, keys)
        project_notify.sendMessage(this.rid, this.pid, '-确认offer', '确认offer', content)
      } else {
        this.$message.error(res.msg)
      }
    },
    changeYongjin() {
      if (this.biliType == '选择比例') {
        const money = parseFloat(this.form.固定年薪)
        const per = parseFloat(this.form.合同比例)
        if (!isNaN(money) && !isNaN(per)) {
          return (this.form.佣金额 = getYongJin(money, per))
        }
      }
      // delete this.form.佣金额
    },
    async confirm() {
      if (
        !this.团队长 ||
        !this.团队长.length ||
        !this.客户维护 ||
        !this.客户维护.length ||
        !this.项目对接 ||
        !this.项目对接.length ||
        !this.项目经理 ||
        !this.项目经理.length
      ) {
        this.$alert('请填写全部责任人！', { showClose: false })
        return
      }
      if (this.团队长.length > 1) {
        this.$alert('团队长只可选择一人！', { showClose: false })
        return
      }
      if (this.客户维护.length > 1) {
        this.$alert('客户维护只可选择一人！', { showClose: false })
        return
      }
      if (this.项目对接.length > 1) {
        this.$alert('项目对接只可选择一人！', { showClose: false })
        return
      }
      let floatNum = /^\d+(\.\d+)?$/
      const form = Object.assign({}, this.form)
      if (!form.职位) return this.$alert('请填写职位', { showClose: false })
      if (!form.固定年薪) return this.$alert('请填写固定年薪', { showClose: false })
      if (!this.beforeConfirmCheck) return this.checkAnnualSalary(true)
      else this.beforeConfirmCheck = true
      if (!form.到岗日期) return this.$alert('请填写到岗日期', { showClose: false })
      if (!form.试用期) return this.$alert('请填写试用期', { showClose: false })
      if (!form.佣金额) return this.$alert('请填写佣金额', { showClose: false })
      if (!floatNum.test(form.固定年薪)) return this.$alert('固定年薪只能填写数字', { showClose: false })
      if (!floatNum.test(form.试用期)) return this.$alert('试用期只能填写数字', { showClose: false })
      if (!floatNum.test(form.佣金额)) return this.$alert('佣金额只能填写数字', { showClose: false })
      if (this.biliType == '选择比例') {
        if (!form.合同比例) return this.$alert('请填写合同比例', { showClose: false })
        if (!floatNum.test(form.合同比例)) return this.$alert('合同比例只能填写数字', { showClose: false })
      }
      this.loading = true
      form.isMaybe = false
      if (this.biliType == '固定收费' || this.biliType == '最低收费') form.合同比例 = this.biliType
      const res = await app
        .service('radish')
        .updateOffer({ rid: this.rid, pid: this.pid, data: this.form, type: 'confirm' })
      if (res.status == 'success') {
        const keys = '候选人、推荐顾问、职位、专业职级、固定年薪、offer签订日期、预计到岗时间、到岗日期、备注'
        const content = project_notify.getContent(this.form, keys)
        project_notify.sendMessage(this.rid, this.pid, '-确认offer', '确认offer', content)
        // await this.addNotify()
        this.$emit('onConfirm')
        this.loading = false
        this.dialogVisible = false
        app.service('radish').initFencheng({
          rid: this.radish._id,
          pid: this.project._id,
          关键决策人: {
            团队长: this.团队长[0],
            客户维护: this.客户维护[0],
            项目对接: this.项目对接[0],
            项目经理: this.项目经理,
          },
        })
        // 添加日历
        const canyu = [form.顾问]
        if (this.project.客户开发) {
          if (Array.isArray(this.project.客户开发) && this.project.客户开发.length > 0) {
            canyu.push(this.project.客户开发[0])
          } else {
            canyu.push(this.project.客户开发)
          }
        }
        const desc = `候选人：${form.候选人 || ''}；职位：${this.project.客户公司 }-${ this.project.项目名称}${form.备注?'；备注：'+form.备注:''}`
        app.service('misc').addRili({
          类型: '到岗',
          时间: new Date(form.到岗日期).getTime(),
          备注: desc,
          参与人: canyu,
          关联人选: this.radish.姓名,
          rid: this.radish._id,
          关联项目: this.project.项目名称,
          pid: this.project._id
        })
      } else {
        this.loading = false
        this.$message.error(res.msg)
      }
    },
    async addNotify(to) {
      let notify = {}
      notify = {
        title: `您有新的业绩分成需要分配`,
        type: '行政',
        action: '业绩分成',
        content: `【${this.project.客户公司}】-【${this.project.项目名称}】有新的成单，请前往分配相关业绩比例`,
        rid: this.radish._id,
        pid: this.project._id,
      }
      const res = await app.service('notify').addNotify({
        notify,
        to: ['charlottewang'],
      })
      if (res.status === 'success') {
      } else {
        this.$message.error(res.msg)
      }
    },
    getZhName(account) {
      const user = app.users.find((u) => u.account === account)
      return (user && user.姓名) || ''
    },
    async open({ radish, project }) {
      this.beforeConfirmCheck = false
      this.radish = radish
      this.project = project
      this.rid = radish.rid || radish._id
      this.pid = project._id
      const offerRes = await app.service('radish').findOffer({ rid: this.rid, pid: this.pid })
      if (offerRes.status === 'success') {
        if (offerRes.data.length > 0) {
          this.form = offerRes.data[0]
          if (app.user.account !== this.form['顾问']) {
            return this.$alert('只有该人选的推荐顾问才能确认offer')
          }
          if (this.form.合同比例 == '固定收费' || this.form.合同比例 == '最低收费') {
            this.biliType = this.form.合同比例
          } else {
            this.biliType = '选择比例'
          }
          this.dialogVisible = true
        } else {
          this.$message.error('未找到对应offer数据')
        }
      } else {
        return this.$message.error(res.msg)
      }
      const res = await app.service('radish').getFencheng({ rid: this.radish._id, pid: this.project._id })
      if (res.status === 'success') {
        this.yejifencheng = res.data
      } else {
        this.$message.error(res.msg)
        console.log(res.msg)
      }
      if (
        this.yejifencheng &&
        !(!this.团队长.length || !this.客户维护.length || !this.项目对接.length || !this.项目经理.length) &&
        this.团队长.length <= 1 &&
        this.客户维护.length <= 1 &&
        this.项目对接.length <= 1
      ) {
        this.showZerenren = false
        return
      }
      this.dialogVisible = true
      this.客户开发 = this.project.客户开发.map((k) => `${k}(${this.getZhName(k)})`).join('、')
      if (this.yejifencheng) {
        this.团队长 = [this.yejifencheng.团队长]
        this.客户维护 = [this.yejifencheng.客户维护]
        this.项目对接 = [this.yejifencheng.项目对接]
        this.项目经理 = this.yejifencheng.项目经理
      } else {
        this.项目对接 = (this.project.项目对接 || []).filter(Boolean)
        this.客户维护 = (this.project.客户维护 || []).filter(Boolean)
        this.项目经理 = (this.project.项目经理 || []).filter(Boolean)
      }
    },
  },
}
</script>
<style scoped>
.tips {
  font-size: 12px;
  color: red;
}
.info-title {
  font-size: 14px;
  margin-bottom: 10px;
}
.info-part {
  margin-bottom: 20px;
}
.info-content {
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  width: 100%;
  padding: 10px;
  flex-wrap: wrap;
  padding-top: 0;
}
.info-item {
  display: flex;
  align-items: center;
  margin-right: 20px;
  font-size: 14px;
  margin-top: 10px;
}
.info-item-title {
  color: #999;
  margin-right: 5px;
}
.info-item-content {
  color: #333;
}
</style>
<style>
@import '../../static/css/progress.css';
</style>
